import { useSetAtom } from 'jotai';
import { useRouter } from 'next/navigation';

import { filtersListAtom } from '@core/Atoms/Plp/FiltersListAtom';
import type { Filter } from '@core/Entities/Search/SearchFilters/Filter.entity';
import { useSyncedAtomRef } from '@core/Hooks/UseSyncedAtomRef';
import { createPathFromFilters } from '@core/Utils/Search/CreatePathFromFilters';
import { filterUpdateStartedAtom } from '@plp/Atoms/FilterUpdateStarted';
import { applyFilterChanges } from '@plp/Utils/Filters/ApplyFiltersChange';
import { useGetRoot } from '@search/Hooks/UseGetRoot';

import { priceTypeAtom } from '../Atom/PriceTypeAtom';

const FORCE_UI_REFRESH = 'fui';

const useUpdateFilters = () => {
  const root = useGetRoot();
  const { push } = useRouter();
  const setFiltersList = useSetAtom(filtersListAtom);
  const setFilterUpdateStarted = useSetAtom(filterUpdateStartedAtom);

  const filtersListRef = useSyncedAtomRef(filtersListAtom);
  const priceTypeRef = useSyncedAtomRef(priceTypeAtom);

  const applyNewFilters = (updatedFilters: Filter[], navigateOpts?: { scroll: boolean }) => {
    let newUrl = createPathFromFilters(updatedFilters, root);

    setFilterUpdateStarted(true);
    const shouldForceUiRefresh = !newUrl.includes('?');

    //NOTE: this is a hack to get around an issue where the PlpWrapper ui does not update when going from /path?withQuery to /path
    if (shouldForceUiRefresh) newUrl = `${newUrl}?${FORCE_UI_REFRESH}`;

    push(newUrl, navigateOpts || { scroll: false });
  };

  const updateFilters = (updates: Filter[], navigateOpts?: { scroll: boolean }) => {
    const unusedPriceFilters =
      priceTypeRef.current === 'monthly-price'
        ? ['price__lte', 'price__gte']
        : ['monthly-price__lte', 'monthly-price__gte'];

    const newFilters = applyFilterChanges(filtersListRef.current, updates);
    if (newFilters) {
      const updatedFilters = newFilters.filter(item => !unusedPriceFilters.includes(item.id));
      setFiltersList(updatedFilters);
      applyNewFilters(updatedFilters, navigateOpts);
    }
  };

  return {
    updateFilters,
  };
};

export { useUpdateFilters };
